import { create } from '@bufbuild/protobuf'
import { t } from 'i18next'

import {
  StatusLabel,
  StatusLabelSchema,
  StatusLabel_Status,
} from '@enechain/eposition-proto/bfftypes/v1/label_pb'
import { OrganizationOptionCategory } from '@enechain/eposition-ui'
import { ECLEAR_OPTION_CATEGORY } from '@enechain/eposition-ui/src/models/eclearOption'

import { ResultSimulationForOption2Model } from '~/pages/Simulation/models/SimulationResultModel/ResultSimulationForOption2Model'

export type MarginSimulationResultForOption2Models = {
  allowDealStatus: StatusLabel
  allLimitAmount: string
  physicalFuturesLimitAmount: string
  details: ResultSimulationForOption2Model[]
  type: OrganizationOptionCategory
}

export function convertMarginSimulationResultForOption2Models(
  models: ResultSimulationForOption2Model[],
): MarginSimulationResultForOption2Models {
  const allowDealStatus = models.every((model) => model.allowDeal)
    ? create(StatusLabelSchema, {
        status: StatusLabel_Status.POSITIVE,
        label: t('domain:model.deal.deal_available.available'),
      })
    : create(StatusLabelSchema, {
        status: StatusLabel_Status.NEGATIVE,
        label: t('domain:model.deal.deal_available.unavailable'),
      })

  return {
    allowDealStatus,
    allLimitAmount: models[0]?.allLimitAmount ?? '-',
    physicalFuturesLimitAmount: models[0]?.physicalFuturesLimitAmount ?? '-',
    details: models,
    type: ECLEAR_OPTION_CATEGORY.OPTION_2,
  }
}
